/* PoojaBooks theme scripts: carousels, cart, wishlist, recently viewed, filters, product page, tabs. */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const strings = window.pbStrings || {};
  const desktop = window.matchMedia('(min-width: 990px)');
  const store = {
    get(key, fallback = []) {
      try {
        const v = JSON.parse(localStorage.getItem(key));
        return v == null ? fallback : v;
      } catch (e) {
        return fallback;
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {
        /* storage unavailable */
      }
    },
  };
  const WISHLIST_KEY = 'pb:wishlist';
  const RECENT_KEY = 'pb:recent';
  const ICON = {
    cart: '<svg class="pb-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M2 3.2c0-.5.4-.9.9-.9h2.3c.6 0 1.1.4 1.2 1l.3 1.6h14.4c.8 0 1.3.7 1.1 1.4l-1.7 6.6a1.8 1.8 0 0 1-1.7 1.4H8.1l.3 1.5h10.8a.9.9 0 1 1 0 1.8H7.7c-.6 0-1.1-.4-1.2-1L4.5 4.1H2.9A.9.9 0 0 1 2 3.2z"/><circle cx="9" cy="20.3" r="1.6"/><circle cx="18" cy="20.3" r="1.6"/></svg>',
    heart: '<svg class="pb-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 20.5S3.5 15.3 3.5 9.2A4.7 4.7 0 0 1 12 6.6a4.7 4.7 0 0 1 8.5 2.6c0 6.1-8.5 11.3-8.5 11.3z"/></svg>',
  };
  const esc = (v) => String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message, isError) {
    const el = document.querySelector('[data-pb-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.toggle('pb-toast--error', !!isError);
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      el.classList.remove('is-visible');
      setTimeout(() => (el.hidden = true), 300);
    }, 2600);
  }

  /* ---------- Carousels ---------- */
  function initCarousel(el) {
    if (el.dataset.pbReady) return;
    const track = el.querySelector('[data-pb-track]');
    if (!track) return;
    el.dataset.pbReady = 'true';
    const prev = el.querySelector('[data-pb-prev]');
    const next = el.querySelector('[data-pb-next]');
    const dotsWrap = el.querySelector('[data-pb-dots]');
    const rtl = () => (getComputedStyle(track).direction === 'rtl' ? -1 : 1);
    const step = () => {
      const first = track.children[0];
      if (!first) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const w = first.getBoundingClientRect().width + gap;
      return Math.max(1, Math.floor((track.clientWidth + gap) / w)) * w;
    };
    let dots = [];
    const buildDots = () => {
      if (!dotsWrap) return;
      const total = track.children.length ? Math.ceil((track.scrollWidth - 2) / Math.max(1, step())) : 0;
      dotsWrap.innerHTML = '';
      dots = [];
      if (total < 2) return;
      for (let i = 0; i < total; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'pb-dots__dot';
        b.setAttribute('aria-label', `स्लाइड ${i + 1}`);
        b.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    };
    const goTo = (i) => {
      const max = track.scrollWidth - track.clientWidth;
      track.scrollTo({ left: rtl() * Math.min(max, i * step()), behavior: 'smooth' });
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      const left = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = left <= 2;
      if (next) next.disabled = left >= max;
      el.classList.toggle('pb-carousel--static', max <= 0);
      const idx = left >= max ? dots.length - 1 : Math.round(left / Math.max(1, step()));
      dots.forEach((d, i) => d.setAttribute('aria-current', i === idx ? 'true' : 'false'));
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -rtl() * step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: rtl() * step(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', () => {
      buildDots();
      update();
    });
    el.pbRefresh = () => {
      buildDots();
      update();
    };
    buildDots();
    update();

    const seconds = parseFloat(el.dataset.autoplay || '0');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (seconds > 0 && !reduce && !(window.Shopify && window.Shopify.designMode)) {
      let timer;
      const stop = () => clearInterval(timer);
      const start = () => {
        stop();
        timer = setInterval(() => {
          if (!el.offsetParent) return;
          const max = track.scrollWidth - track.clientWidth - 2;
          if (Math.abs(track.scrollLeft) >= max) goTo(0);
          else track.scrollBy({ left: rtl() * step(), behavior: 'smooth' });
        }, seconds * 1000);
      };
      el.addEventListener('mouseenter', stop);
      el.addEventListener('mouseleave', start);
      el.addEventListener('focusin', stop);
      el.addEventListener('focusout', start);
      track.addEventListener('touchstart', stop, { passive: true });
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
      start();
    }
  }

  /* ---------- Cart ---------- */
  async function refreshCartCount() {
    try {
      const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
      document.querySelectorAll('[data-pb-cart-count]').forEach((el) => (el.textContent = cart.item_count));
    } catch (e) {
      /* ignore */
    }
  }

  async function addToCart(formData, button) {
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    }
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        toast(data.description || data.message || strings.error, true);
        return;
      }
      toast(strings.addedToCart || 'कार्ट में जोड़ा गया ✓');
      await refreshCartCount();
      document.dispatchEvent(new CustomEvent('pb:cart-updated'));
    } catch (e) {
      toast(strings.error, true);
    } finally {
      if (button) {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-pb-atc]');
    if (!form) return;
    const submitter = event.submitter;
    if (submitter && submitter.name === 'return_to') return; // "Buy now" goes straight to checkout
    event.preventDefault();
    addToCart(new FormData(form), submitter || form.querySelector('[type="submit"]'));
  });

  document.addEventListener('click', (event) => {
    const proxy = event.target.closest('[data-pb-submit-form]');
    if (!proxy) return;
    const form = document.getElementById(proxy.dataset.pbSubmitForm);
    if (!form) return;
    event.preventDefault();
    addToCart(new FormData(form), proxy);
  });

  /* ---------- Wishlist ---------- */
  const wishlist = {
    all: () => store.get(WISHLIST_KEY),
    has: (handle) => wishlist.all().some((p) => p.handle === handle),
    toggle(product) {
      const list = wishlist.all();
      const idx = list.findIndex((p) => p.handle === product.handle);
      if (idx > -1) list.splice(idx, 1);
      else list.unshift(product);
      store.set(WISHLIST_KEY, list.slice(0, 60));
      return idx === -1;
    },
  };

  function syncHearts(scope = document) {
    scope.querySelectorAll('[data-pb-wishlist-toggle]').forEach((btn) => {
      try {
        btn.setAttribute('aria-pressed', wishlist.has(JSON.parse(btn.dataset.product).handle) ? 'true' : 'false');
      } catch (e) {
        /* ignore */
      }
    });
    const count = wishlist.all().length;
    document.querySelectorAll('[data-pb-wishlist-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-pb-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    let product;
    try {
      product = JSON.parse(btn.dataset.product);
    } catch (e) {
      return;
    }
    toast(wishlist.toggle(product) ? strings.addedToWishlist : strings.removedFromWishlist);
    syncHearts();
    renderStoredLists();
  });

  /* ---------- Client-rendered cards ---------- */
  function compactCard(p, withHeart) {
    const img = p.image ? `<img src="${esc(p.image)}" alt="${esc(p.title)}" loading="lazy" width="360" height="360">` : '';
    const action = p.variant
      ? `<form method="post" action="${root}cart/add" class="pb-atc" data-pb-atc><input type="hidden" name="id" value="${esc(p.variant)}"><input type="hidden" name="quantity" value="1"><button type="submit" class="pb-btn pb-btn--icon" aria-label="कार्ट में जोड़ें: ${esc(p.title)}">${ICON.cart}</button></form>`
      : `<a href="${esc(p.url)}" class="pb-btn pb-btn--icon" aria-label="${esc(p.title)}">${ICON.cart}</a>`;
    const heart = withHeart
      ? `<button type="button" class="pb-heart" data-pb-wishlist-toggle data-product="${esc(JSON.stringify(p))}" aria-pressed="false" aria-label="पसंद सूची: ${esc(p.title)}">${ICON.heart}</button>`
      : '';
    const sub = p.subtitle ? `<p class="pb-card__subtitle">${esc(p.subtitle)}</p>` : '';
    return `<div class="pb-card pb-card--compact"><div class="pb-card__media-wrap"><a class="pb-card__media" href="${esc(p.url)}" tabindex="-1" aria-hidden="true">${img}</a>${heart}</div><div class="pb-card__body"><h3 class="pb-card__title"><a href="${esc(p.url)}">${esc(p.title)}</a></h3>${sub}<div class="pb-card__foot"><div class="pb-price"><span class="pb-price__now">${esc(p.price)}</span></div>${action}</div></div></div>`;
  }

  function renderStoredLists() {
    document.querySelectorAll('[data-pb-recent]').forEach((section) => {
      const limit = parseInt(section.dataset.limit || '8', 10);
      const items = store.get(RECENT_KEY).filter((p) => p.handle !== section.dataset.exclude).slice(0, limit);
      const track = section.querySelector('[data-pb-track]');
      section.hidden = items.length === 0;
      if (!track) return;
      track.innerHTML = items.map((p) => `<div class="pb-carousel__slide">${compactCard(p, section.dataset.hearts === 'true')}</div>`).join('');
      const c = section.querySelector('[data-pb-carousel]');
      if (c) (c.pbRefresh ? c.pbRefresh() : initCarousel(c));
      syncHearts(section);
    });
    document.querySelectorAll('[data-pb-wishlist-grid]').forEach((grid) => {
      const items = wishlist.all();
      grid.innerHTML = items.map((p) => compactCard(p, true)).join('');
      const empty = grid.parentElement.querySelector('[data-pb-wishlist-empty]');
      if (empty) empty.hidden = items.length > 0;
      syncHearts(grid);
    });
  }

  function trackRecentlyViewed() {
    const el = document.querySelector('[data-pb-recent-track]');
    if (!el) return;
    try {
      const product = JSON.parse(el.textContent);
      const list = store.get(RECENT_KEY).filter((p) => p.handle !== product.handle);
      list.unshift(product);
      store.set(RECENT_KEY, list.slice(0, 16));
    } catch (e) {
      /* ignore */
    }
  }

  /* ---------- WhatsApp: add the current page to the message ---------- */
  function whatsappText() {
    const wa = window.pbWhatsApp || {};
    const lines = [];
    if (wa.message) lines.push(wa.message);
    const url = location.origin + location.pathname + (new URLSearchParams(location.search).get('variant') ? `?variant=${new URLSearchParams(location.search).get('variant')}` : '');
    const product = document.querySelector('[data-pb-product]');
    if (product) {
      const title = (product.querySelector('.pb-pdp__title') || {}).textContent;
      const sub = (product.querySelector('.pb-pdp__subtitle') || {}).textContent;
      const price = (product.querySelector('[data-pb-price-now]') || {}).textContent;
      if (wa.productLabel) lines.push('', wa.productLabel);
      lines.push([title, sub].filter(Boolean).map((t) => t.trim()).join(' ') + (price ? ` – ${price.trim()}` : ''));
      lines.push(url);
    } else if (location.pathname !== '/' && location.pathname !== root) {
      const heading = document.querySelector('main h1') || document.querySelector('h1');
      const name = (heading && heading.textContent.trim()) || document.title;
      lines.push('', `${wa.pageLabel ? wa.pageLabel + ' ' : ''}${name}`, url);
    } else {
      lines.push('', url);
    }
    return lines.join('\n').trim();
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com/"], a[href*="whatsapp.com/send"]');
    if (!link || !(window.pbWhatsApp && window.pbWhatsApp.addPage)) return;
    try {
      const u = new URL(link.href);
      u.searchParams.set('text', whatsappText());
      link.href = u.toString();
    } catch (e) {
      /* leave the link unchanged */
    }
  });

  /* ---------- Share ---------- */
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-pb-share]');
    if (!btn) return;
    const data = { title: btn.dataset.title || document.title, url: btn.dataset.url || location.href };
    try {
      if (navigator.share) await navigator.share(data);
      else {
        await navigator.clipboard.writeText(data.url);
        toast(strings.linkCopied);
      }
    } catch (e) {
      /* cancelled */
    }
  });

  /* ---------- Drawers (mobile menu, mobile filters) ---------- */
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.hidden = false;
    document.documentElement.classList.add('pb-lock');
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    const focusable = drawer.querySelector('button, a, input, select');
    focusable && focusable.focus();
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('pb-lock');
    setTimeout(() => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 250);
    const opener = document.querySelector(`[data-pb-drawer-open="${drawer.id}"]`);
    opener && opener.focus();
  }
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-pb-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.dataset.pbDrawerOpen);
      return;
    }
    const closer = event.target.closest('[data-pb-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('.pb-drawer'));
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer(document.querySelector('.pb-drawer.is-open'));
  });

  /* ---------- Collection: filters, sort, view ---------- */
  function initCollection(section) {
    if (section.dataset.pbReady) return;
    section.dataset.pbReady = 'true';
    const sectionId = section.dataset.sectionId;
    const form = section.querySelector('[data-pb-filters-form]');
    const sort = section.querySelector('[data-pb-sort]');

    const openDesktopFilters = () => {
      if (desktop.matches) section.querySelectorAll('[data-pb-desktop-open]').forEach((d) => (d.open = true));
    };

    const applyView = () => {
      const mode = store.get('pb:view', 'grid');
      section.querySelectorAll('[data-pb-results] .pb-grid').forEach((g) => g.classList.toggle('pb-grid--list', mode === 'list' && !desktop.matches));
      section.querySelectorAll('[data-pb-view]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.pbView === mode ? 'true' : 'false'));
    };

    const render = async (url, push = true) => {
      section.classList.add('is-loading');
      try {
        const u = new URL(url, location.origin);
        u.searchParams.set('section_id', sectionId);
        const doc = new DOMParser().parseFromString(await (await fetch(u.toString())).text(), 'text/html');
        ['[data-pb-results]', '[data-pb-count]', '[data-pb-count-num]', '[data-pb-count-desktop]', '[data-pb-filter-body]', '[data-pb-active-filters]'].forEach((sel) => {
          const fresh = doc.querySelector(sel);
          if (fresh) section.querySelectorAll(sel).forEach((el) => (el.innerHTML = fresh.innerHTML));
        });
        if (push) {
          u.searchParams.delete('section_id');
          history.pushState({ pbFilters: true }, '', u.toString());
        }
        openDesktopFilters();
        applyView();
        syncHearts(section);
      } catch (e) {
        location.href = url;
      } finally {
        section.classList.remove('is-loading');
      }
    };

    const urlFromForm = () => {
      const params = form ? new URLSearchParams(new FormData(form)) : new URLSearchParams(location.search);
      for (const [key, value] of Array.from(params.entries())) if (value === '') params.delete(key);
      params.delete('page');
      if (sort && sort.value) params.set('sort_by', sort.value);
      return `${(form && form.getAttribute('action')) || location.pathname}?${params.toString()}`;
    };

    if (form) {
      form.addEventListener('change', (event) => {
        if (event.target.matches('input[type="number"]')) return;
        render(urlFromForm());
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        render(urlFromForm());
        const drawer = form.closest('.pb-drawer');
        if (drawer && drawer.classList.contains('is-open')) closeDrawer(drawer);
      });
    }
    sort && sort.addEventListener('change', () => render(urlFromForm()));
    section.addEventListener('click', (event) => {
      const link = event.target.closest('[data-pb-filter-link]');
      if (link) {
        event.preventDefault();
        render(link.href);
        return;
      }
      const more = event.target.closest('[data-pb-show-more]');
      if (more) {
        more.closest('.pb-filter').classList.add('is-expanded');
        more.remove();
        return;
      }
      const view = event.target.closest('[data-pb-view]');
      if (view) {
        store.set('pb:view', view.dataset.pbView);
        applyView();
      }
    });
    window.addEventListener('popstate', () => render(location.href, false));
    desktop.addEventListener('change', () => {
      openDesktopFilters();
      applyView();
      const drawer = section.querySelector('.pb-drawer.is-open');
      if (drawer && desktop.matches) closeDrawer(drawer);
    });
    openDesktopFilters();
    applyView();
  }

  /* ---------- Recommendations ---------- */
  async function loadRecommendations(el) {
    if (el.dataset.pbLoaded) return;
    el.dataset.pbLoaded = 'true';
    try {
      const doc = new DOMParser().parseFromString(await (await fetch(el.dataset.url)).text(), 'text/html');
      const fresh = doc.querySelector(`[data-pb-recommendations="${el.dataset.pbRecommendations}"]`);
      const wrap = el.closest('.shopify-section');
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        el.querySelectorAll('[data-pb-carousel]').forEach(initCarousel);
        syncHearts(el);
      } else if (wrap) wrap.classList.add('pb-hidden');
    } catch (e) {
      /* leave empty */
    }
  }

  function wideCard(p) {
    const money = (cents) => (window.Shopify && window.Shopify.formatMoney ? window.Shopify.formatMoney(cents) : `₹${Math.round(cents / 100)}`);
    const v = p.variants && p.variants.find((x) => x.available);
    const off = p.compare_at_price > p.price ? Math.floor(((p.compare_at_price - p.price) * 100) / p.compare_at_price) : 0;
    const img = p.featured_image ? `<img src="${esc(p.featured_image)}" alt="${esc(p.title)}" loading="lazy">` : '';
    const badge = (p.tags || []).find((t) => t.indexOf('badge:') === 0);
    const tag = badge ? `<span class="pb-tag pb-tag--red">${esc(badge.slice(6).split('|')[0])}</span>` : '';
    const action =
      v && p.variants.length === 1
        ? `<form method="post" action="${root}cart/add" class="pb-atc" data-pb-atc><input type="hidden" name="id" value="${v.id}"><input type="hidden" name="quantity" value="1"><button type="submit" class="pb-btn pb-btn--block">${ICON.cart}<span>कार्ट में जोड़ें</span></button></form>`
        : `<a href="${esc(p.url)}" class="pb-btn pb-btn--block">देखें</a>`;
    return `<div class="pb-carousel__slide"><div class="pb-card pb-card--wide"><div class="pb-card__media-wrap"><a class="pb-card__media" href="${esc(p.url)}" tabindex="-1" aria-hidden="true">${img}</a>${tag}</div><div class="pb-card__body"><h3 class="pb-card__title"><a href="${esc(p.url)}">${esc(p.title)}</a></h3><div class="pb-card__foot"><div class="pb-price"><span class="pb-price__now">${money(p.price)}</span>${off ? `<s class="pb-price__was">${money(p.compare_at_price)}</s><span class="pb-badge">${off}% OFF</span>` : ''}</div>${action}</div></div></div></div>`;
  }

  async function loadCombo(el) {
    if (el.dataset.pbLoaded) return;
    el.dataset.pbLoaded = 'true';
    try {
      const data = await (await fetch(el.dataset.url)).json();
      const items = (data.products || []).filter((p) => p.available);
      if (!items.length) return;
      el.querySelector('[data-pb-track]').innerHTML = items.map(wideCard).join('');
      el.hidden = false;
      const c = el.querySelector('[data-pb-carousel]');
      c && initCarousel(c);
    } catch (e) {
      /* leave hidden */
    }
  }

  /* ---------- Product page ---------- */
  function initProduct(section) {
    if (section.dataset.pbReady) return;
    section.dataset.pbReady = 'true';

    const gallery = section.querySelector('[data-pb-gallery]');
    if (gallery) {
      const track = gallery.querySelector('[data-pb-track]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-pb-thumb]'));
      const thumbsWrap = gallery.querySelector('.pb-gallery__thumbs');
      const setActive = (i) => {
        thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
        const t = thumbs[i];
        if (!t || !thumbsWrap) return;
        // Keep the active thumbnail visible inside the scrolling strip without moving the page.
        const vertical = thumbsWrap.scrollHeight > thumbsWrap.clientHeight + 1;
        if (vertical) {
          const top = t.getBoundingClientRect().top - thumbsWrap.getBoundingClientRect().top + thumbsWrap.scrollTop;
          if (top < thumbsWrap.scrollTop || top + t.offsetHeight > thumbsWrap.scrollTop + thumbsWrap.clientHeight)
            thumbsWrap.scrollTo({ top: top - (thumbsWrap.clientHeight - t.offsetHeight) / 2, behavior: 'smooth' });
        } else if (thumbsWrap.scrollWidth > thumbsWrap.clientWidth + 1) {
          const left = t.getBoundingClientRect().left - thumbsWrap.getBoundingClientRect().left + thumbsWrap.scrollLeft;
          thumbsWrap.scrollTo({ left: left - (thumbsWrap.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        }
      };
      thumbs.forEach((thumb, i) =>
        thumb.addEventListener('click', () => {
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
          setActive(i);
        })
      );
      track &&
        track.addEventListener(
          'scroll',
          () => {
            const i = Math.round(Math.abs(track.scrollLeft) / Math.max(1, track.clientWidth));
            setActive(i);
            track.querySelectorAll('video').forEach((v) => {
              if (v.closest('[data-index]') && v.closest('[data-index]').dataset.index != i) v.pause();
            });
          },
          { passive: true }
        );
    }

    section.querySelectorAll('[data-pb-qty]').forEach((wrap) => {
      const input = wrap.querySelector('input');
      wrap.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-pb-qty-step]');
        if (!btn) return;
        const min = parseInt(input.min || '1', 10);
        input.value = Math.max(min, (parseInt(input.value, 10) || min) + parseInt(btn.dataset.pbQtyStep, 10));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    const variantsEl = section.querySelector('[data-pb-variants-json]');
    const select = section.querySelector('[data-pb-variant-select]');
    if (variantsEl && select) {
      const variants = JSON.parse(variantsEl.textContent);
      select.addEventListener('change', () => {
        const v = variants.find((x) => String(x.id) === select.value);
        if (!v) return;
        section.querySelectorAll('[data-pb-price-now]').forEach((el) => (el.textContent = v.price));
        section.querySelectorAll('[data-pb-price-was]').forEach((el) => {
          el.textContent = v.compare || '';
          el.hidden = !v.compare;
        });
        section.querySelectorAll('[data-pb-price-off]').forEach((el) => {
          el.textContent = v.off ? `${v.off}% OFF` : '';
          el.hidden = !v.off;
        });
        section.querySelectorAll('[data-pb-saving]').forEach((el) => {
          el.hidden = !v.saving;
          const amount = el.querySelector('[data-pb-saving-amount]');
          if (amount) amount.textContent = v.saving || '';
        });
        section.querySelectorAll('[data-pb-add], [data-pb-buy], [data-pb-add-proxy]').forEach((b) => (b.disabled = !v.available));
        section.querySelectorAll('[data-pb-stock]').forEach((el) => el.classList.toggle('is-out', !v.available));
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      });
    }

    const sticky = section.querySelector('[data-pb-sticky]');
    const anchor = section.querySelector('[data-pb-add]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passed);
        document.documentElement.classList.toggle('pb-has-sticky', passed);
      }).observe(anchor);
    }

    section.querySelectorAll('[data-pb-combo]').forEach(loadCombo);
  }

  /* ---------- Tabs ---------- */
  function initTabs(wrap) {
    if (wrap.dataset.pbReady) return;
    wrap.dataset.pbReady = 'true';
    const tabs = Array.from(wrap.querySelectorAll('[data-pb-tab]'));
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    };
    tabs.forEach((t, i) => {
      t.tabIndex = i === 0 ? 0 : -1;
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        select(n);
        n.focus();
      });
    });
    // On mobile only the first panel is shown, so reset when switching layouts.
    desktop.addEventListener('change', () => {
      if (!desktop.matches && tabs[0]) select(tabs[0]);
    });
  }

  /* ---------- Init ---------- */
  function init(scope = document) {
    scope.querySelectorAll('[data-pb-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-pb-collection]').forEach(initCollection);
    scope.querySelectorAll('[data-pb-product]').forEach(initProduct);
    scope.querySelectorAll('[data-pb-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-pb-recommendations]').forEach(loadRecommendations);
    syncHearts(scope);
  }

  const boot = () => {
    trackRecentlyViewed();
    init();
    renderStoredLists();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
    renderStoredLists();
  });
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-pb-track] > *');
    if (slide && slide.parentElement) slide.parentElement.scrollTo({ left: slide.offsetLeft - slide.parentElement.offsetLeft, behavior: 'smooth' });
  });
})();
